import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import getCompanySpecificConfig from './getCompanySpecificConfig'
import getChosenJobLayout from './getChosenJobLayout'
import callDataPrivHTML from './callDataPrivHTML'

Vue.use(Vuex)

export default new Vuex.Store({
  //Data
  state: {
    //MAIN
      templateName: "",
      show: false,
      results: [],
      firstName: "",
      lastName: "",
      salutation: "",
      phone: "",
      primaryEmail: "",
      city: "",
      zip: "",
      state: "",
      country: "",
      address: "",
      password: "",
      cvObject: undefined,
      miscUploadObject: [],
      coverLetterObject: undefined,
      overlay: true,
      success: false,
      failure: false,
      error: false,
      progresscicle: true,
      checkbox: false,
      sfDataResponse: "",
      SFResponse: "",
      terms: false,
      agreement: false,
      dialog: false,
      answers: [""],
      visibility: "",
      availableLanguages: ['de_DE', 'en_US', 'en_UK', 'ro_RO', 'sv_SE', 'cs_CZ', 'hu_HU'], //Update langugages also in Swift when adding here!
      availableLanguagesViewModel: [{lang: '', desc: ''}],
      pickedLanguage: "en_US",
      rerender: 0,
      picRotation: true,
      disabledAnswer: "",
      romanianAnswer: "",
      companySpecificConfig:  [],
      pickedLayout: {pictures:[]},
      system: "",
      reqId: "",
      privacyHTML: ""
    
  },
  //Call-Funcs gegen Data?
  mutations: {

    initCompanySpecificConfig(state, data) {
      state.companySpecificConfig = data
    },
    setPost(state, data) {
      state.results = data.data;
    },
    serverResponse(state, data) {
      state.serverResponse = data
    },
    toggleOverlay(state, data) {
      state.overlay = data
    },
    toggleSuccess(state, data) {
      state.success = data
    },
    toggleFailure(state, data) {
      state.failure = data
    },
    toggleProgressCicle(state, data){
      state.progresscicle = data
    },
    updateError(state, data) {
      state.error = data
    },
    updateFirstName(state, data) {
      state.firstName = data
    },
    updateLastName(state, data) {
      state.lastName = data
    },
    updateSalutation(state, data) {
      state.salutation = data
    },
    updatePhone(state, data) {
      state.phone = data
    },
    updatePrimaryEmail(state, data) {
      state.primaryEmail = data
    },
    updateCity(state, data) {
      state.city = data
    },
    updateZip(state, data) {
      state.zip = data
    },
    updateState(state, data) {
      state.state = data
    },
    updateCountry(state, data) {
      state.country = data
    },
    updateAddress(state, data) {
      state.address = data
    },
    updatePassword(state, data) {
      state.password = data
    },
    updateCVObject(state, data) {
      state.cvObject = data
    },
    updateMiscUploadObject(state, data) {
      state.miscUploadObject = data
    },
    updateCoverLetterObject(state, data) {
      state.coverLetterObject = data
    },
    updatesfDataResponse(state, data) {
      state.sfDataResponse = data
    },
    updateSFResponse(state, data) {
      state.SFResponse = data
    },
    updateAnswers(state, data) {
      state.answers = data
    },
    updateDisabledAnswer(state, data) {
      state.disabledAnswer = data
    },
    updateRomanianAnswer(state, data) {
      state.romanianAnswer = data
    },
    updateLanguage(state, data) {
      state.pickedLanguage = data
    },
    updateavailableLanguagesViewModel(state, data) {
      state.availableLanguagesViewModel = data
    },
    updateAvailableLangugaes(state, data) {
      state.availableLanguages = data
    },
    updateVisibility(state, data) {
      state.visibility = data
    },
    updatePicRotation(state, data) {
      state.picRotation = data
    },
    updatePickedLayout(state, data) {
      state.pickedLayout = data
    },
    updateSystem(state, data) {
      state.system = data
    },
    updateReqId(state, data) {
      state.reqId = data
    },
    updatePrivacyHTML(state, data) {
      state.privacyHTML = data
    },
    updateTemplateName(state, data)  {
      state.templateName = data
    },
    spliceAdditionalDocuments(state, index) {
      state.miscUploadObject.splice(index, 1)
    },   
    //Updates the rerender counter by one. Simply to update the mainview template
    updateRerender(state) {
      state.rerender = state.rerender += 1
    }
  },
  //Quasi als Query verwendbar; Action löst eine Mutation aus
  actions: {

    async deleteAdditionalDocument(context, index) {
      context.commit("spliceAdditionalDocuments", index)
    },

    async getPost(context, url) {

      //Overlay aktivieren,
      context.commit("toggleOverlay", true);
      // console.log(url);

      let ocaId = ""
      let pickedLanguage = ""

      await axios
        .get(url, {
        })
        .then((response) => {
          console.log(response.data)
          context.commit("updateAvailableLangugaes", response.data.availableLanguages)
          context.commit("setPost", response);          
          context.commit("updatesfDataResponse", response.statusText)
          context.commit("updateLanguage", response.data.thisLanguage)
          context.commit("updateRerender")
          context.commit("toggleOverlay", false);
          context.commit("toggleProgressCicle", false);
          let config = getCompanySpecificConfig(response.data.recruitingREG)
          context.commit("initCompanySpecificConfig", config)
          
          // Check in templateName for SWE to set meta pixel
          if (response.data.templateName == "Job Requisition SWE" ) {
            
            let metaScript= document.createElement('script')
            metaScript.setAttribute('src', '/assets/jobtipTrackingScript.js#/')
            document.head.appendChild(metaScript)
            console.log("Tracker")
        
          }


          ocaId = config.ocaId
          pickedLanguage = response.data.thisLanguage

          let layout = getChosenJobLayout(config.jobLayout, response.data.jobLayout)
          context.commit("updatePickedLayout", layout)

          const languages = response.data.availableLanguages.map ( i => {
            if (i == "en_US" ) {
              return { lang: i, desc: 'English (US)' }
            }
            if (i == "de_DE" ) {
              return { lang: i, desc: 'Deutsch' }
            }
            if (i == "en_GB" ) {
              return { lang: i, desc: 'English (GB)' }
            }
            if (i == "ro_RO" ) {
              return { lang: i, desc: 'Romanian' }
            }
            if (i == "sv_SE" ) {
              return { lang: i, desc: 'Swedish' }
            }
            if (i == "cs_CZ" ) {
              return { lang: i, desc: 'Czech' }
            }
            if (i == "hu_HU" ) {
              return { lang: i, desc: 'Hungarian' }
            }
          })
          
          context.commit("updateavailableLanguagesViewModel", languages);

        })

        .catch((error) => {
          console.log(error);
          let reason = error.response.data.reason
          context.commit("updatesfDataResponse", reason)
          context.commit("toggleProgressCicle", false);
          context.commit("toggleFailure", true);
        });

        await callDataPrivHTML(ocaId, pickedLanguage).then ((htmlResult) => {
          
          context.commit("updatePrivacyHTML", htmlResult.result);          

        }).catch((error) => {
        console.log(error.data)
        })

    },
  },

  getters: {
      
  },
})